/* Decorative motion only: bounded entry treatment, no scrolling or content transitions. */
(() => {
  if(window.PCCohesion){window.PCCohesion.scan();return}
  const records=new Map(),reduced=matchMedia('(prefers-reduced-motion: reduce)');
  let host,observer;
  function sync(){
    host=document.querySelector('[data-signal-journey]');if(!host)return;
    host.dataset.cohesionMotion=String(!reduced.matches&&!navigator.connection?.saveData&&document.querySelector('[data-signal-field]')?.dataset.motion!=='static');
    host.classList.toggle('pc-cohesion-hidden',document.hidden);
  }
  function scan(scope=document){
    sync();
    if(!('IntersectionObserver'in window))return;
    observer??=new IntersectionObserver(entries=>entries.forEach(({target,isIntersecting,intersectionRatio})=>{
      target.dataset.cohesionVisible=String(isIntersecting);
      if(isIntersecting&&(!target.hasAttribute('data-cohesion-mid')||intersectionRatio>=.35))target.classList.add('pc-cohesion-entered');
    }),{threshold:[0,.12,.35],rootMargin:'-80px 0px -5% 0px'});
    scope.querySelectorAll('[data-cohesion-colour],[data-cohesion-mid]').forEach(el=>{
      if(records.has(el))return;records.set(el,true);el.dataset.cohesionVisible='false';observer.observe(el);
    });
  }
  document.addEventListener('shopify:section:load',e=>scan(e.target));
  document.addEventListener('shopify:section:unload',e=>{for(const el of records.keys())if(e.target.contains(el)){observer?.unobserve(el);records.delete(el)}});
  document.addEventListener('visibilitychange',sync);
  reduced.addEventListener('change',sync);
  window.addEventListener('pagehide',()=>host?.classList.add('pc-cohesion-hidden'));
  window.addEventListener('pageshow',sync);
  window.PCCohesion={scan};scan();
})();
